import actions from './actions'
import channel from './channel'
import clinicalProfile from './clinicalProfile'
import clinicalRecord from './clinicalRecord'
import demands from './demands'
import getters from './getters'
import healthPlan from './healthPlan'
import mutations from './mutations'
import profile from './profile'
import refreshControl from './refreshControl'
import state from './state'
import testResults from './testResults'
import timeline from './timeline'

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
  modules: {
    channel,
    clinicalProfile,
    clinicalRecord,
    demands,
    healthPlan,
    profile,
    refreshControl,
    testResults,
    timeline
  }
}
